<template>
  <div class="savePicture">
    <div class="savepicture-content">
      <img :src="url.src" alt="" width="100%">
    </div>
    <!--    <div class="savePicture_element">-->
    <!--      <font-awesome-icon @click="saveImg" class="savePicture_icon" icon="check"/>-->
    <!--      <font-awesome-icon @click="deleteImg" class="savePicture_icon" icon="times"/>-->
    <!--    </div>-->
  </div>
</template>

<script>
import {store} from '../../../store/store';
import {mapActions} from "vuex";

export default {
  name: 'savePicture',
  props: {
    url: Object,
    removeMedia: Function
  },
  data() {
    return {
      store,
      showMsg: false,
    }
  },
  methods: {
    ...mapActions([
      'addPicture'
    ]),
    saveImg() {


    },
    deleteImg() {
    },
    getUrl(url) {
      // console.log(url)
    }
  }
}
</script>

<style>
.savePicture {
  width: 100%;
  background: #000;
  height: 100vh;
  display: flex;
}

.savePicture_element {
  display: flex;
}

.savePicture_icon {
  color: white;
  font-size: 30px;
  margin-right: 10px;
}

.savepicture-content {
  margin: auto;
  margin-top: 10px;
  width: 90vw;
  max-height: 80vh;
  background-size: contain !important;
  background-repeat: no-repeat !important;
  border-radius: 10px;
  transform: rotateY(180deg);
  overflow: hidden;

}

@media screen and (max-width: 750px) {
  .savepicture-content {
    margin-top: env(safe-area-inset-top);
  }
}
</style>
